import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Hero.module.css";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PublicIcon from '@mui/icons-material/Public';

function Hero() {
    const navigate = useNavigate();

    function goToPortal() {
        navigate("/auth/register");
    }

    function goToQuickStart() {
        navigate("/quickstart");
    }

    return (
        <div className={styles["hero-container"]}>
            <div className={styles["hero-content"]}>
                {/* Main headline */}
                <h1 className={styles["hero-title"]}>
                    The Sixth Sense for Your Software
                </h1>
                
                {/* Subtitle */}
                <p className={styles["hero-subtitle"]}>
                    Embed our contactless Human Sensing Layer to build the next generation of personalized, human-aware applications.
                </p>

                {/* Feature callouts */}
                <div className={styles["feature-callouts"]}>
                    <div className={styles["callout"]}>
                        <CheckCircleIcon className={styles["callout-icon"]} aria-hidden="true" />
                        <span>No Hardware or Wearables Required</span>
                    </div>
                    <div className={styles["callout"]}>
                        <CameraAltIcon className={styles["callout-icon"]} aria-hidden="true" />
                        <span>Works with Smartphones & Cameras</span>
                    </div>
                    <div className={styles["callout"]}>
                        <PublicIcon className={styles["callout-icon"]} aria-hidden="true" />
                        <span>Ready for the Real World</span>
                    </div>
                </div>

                {/* CTA buttons */}
                <div className={styles["cta-buttons"]}>
                    <button 
                        className={styles["btn-primary"]}
                        onClick={goToPortal}
                    >
                        Start Free Trial
                    </button>
                    <button 
                        className={styles["btn-secondary"]}
                        onClick={goToQuickStart}
                    >
                        View Quick Start Guide
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Hero;